import React, { useImperativeHandle, useRef, useState } from "react";
import styles from "./index.module.scss";
import Webcam from "react-webcam";
import { useInterval, useUpdateEffect } from "react-use";

export interface FloatWebCamInstance {
    getSnapshot: () => string;
}

const FloatWebCam = React.forwardRef<FloatWebCamInstance, {}>((props, ref) => {
    const [active, setActive] = useState(false);
    const [error, setError] = useState<any>();

    const webcamRef = useRef<Webcam>(null);

    useImperativeHandle(ref, () => ({
        getSnapshot: () => {
            return webcamRef.current?.getScreenshot() || "";
        }
    }));

    useInterval(() => {
        setActive(webcamRef.current?.stream?.active || false);
    }, 1000);

    // 使用中状态变化
    useUpdateEffect(() => {
        setError(active ? undefined : "webcam error");
    }, [active]);

    function onUserMedia(stream: MediaStream) {
        setError(undefined);
        setActive(true);
    }

    function onUserMediaError(error: any) {
        setError(error);
    }

    return (
        <div className={styles.root}>
            <h1 className={styles.title}>摄像头的实时画面</h1>

            <div className={styles.body}>
                {!error && (
                    <Webcam
                        ref={webcamRef}
                        onUserMedia={onUserMedia}
                        onUserMediaError={onUserMediaError}
                        minScreenshotHeight={400}
                        minScreenshotWidth={600}
                        screenshotQuality={0.8}
                        screenshotFormat="image/jpeg"
                    />
                )}

                {error && <div className={styles.error}>实时画面采集失败</div>}
            </div>

            <div className={styles.footer}>
                考试过程中请确保自己在摄像区域内
            </div>
        </div>
    );
});

export default FloatWebCam;
